import {
  Box,
  Button,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getRegions } from '../../actions/adminActions';
import {
  getFlightTestPlansForCell,
} from '../../actions/flightTestPlanActions';
import { getLandingPads } from '../../actions/liveAircraftActions';
import { getCells } from '../../actions/orderActions';
import useInterval from '../../utils/useInterval';
import { FlightTestContext } from './FlightTestContext';

const ViewFlightTestPlans = ({
  cells,
  testPlans,
  getCells,
  getRegions,
  getLandingPads,
  getFlightTestPlansForCell
}) => {
  let navigate = useNavigate();
  const [selected, setSelected] = useState({});
  const [menuOpen, setMenuOpen] = useState(false);

  const [cell, setCell] = useState(
    cells?.find(c => c.cellType === 'TEST')?.id || 3
  );

  useEffect(() => {
    getLandingPads();
    getFlightTestPlansForCell(cell);
    getRegions();
    getCells();
  }, []);

  useInterval(() => {
    getFlightTestPlansForCell(cell);
  }, 10000);

  const createNewPlan = () => {
    navigate('../new', { replace: true });
  };

  const handleClick = testPlan => {
    setSelected(testPlan);
    setMenuOpen(true);
  };

  const handleClose = () => {
    if (menuOpen === true && selected !== null) {
      setSelected(null);
      setMenuOpen(false);
    }
  };

  const handleCellUpdate = (ev: SelectChangeEvent<number>) => {
    setCell(ev.target.value);
    getFlightTestPlansForCell(ev.target.value);
  };

  return (
    <div style={{ backgroundColor: 'white', height: '100%', padding: '12px 6px' }} onClick={() => handleClose()}>
      <div style={{ marginBottom: 12 }}>
        <Button
          variant="contained"
          type="button"
          color="primary"
          onClick={createNewPlan}>
          Create new test plan
        </Button>
        <Button
          sx={{ marginLeft: 6, marginRight: 6 }}
          variant="contained"
          type="button"
          color="primary"
          onClick={() => {
            getFlightTestPlansForCell(cell);
          }}>
          Refresh
        </Button>
        <Select
          value={cell}
          variant="standard"
          sx={{ width: 320 }}
          onChange={handleCellUpdate}>
          {cells
            ?.filter(c => c.cellType === 'TEST')
            .map(c => {
              return (
                <MenuItem key={`cell-${c.id}`} value={c.id}>
                  <Box
                    sx={{}}
                    alignItems="center"
                    display={'flex'}
                    flexGrow={1}
                    justifyContent="center">
                    <Box display={'flex'}>
                      <Typography variant="h6">{c.cellName}</Typography>
                    </Box>
                  </Box>
                </MenuItem>
              );
            })}
        </Select>
      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="assets table">
          <TableHead>
            <TableRow>
              <TableCell>Cell</TableCell>
              <TableCell>Generated Cell</TableCell>
              <TableCell>End date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Note</TableCell>
              <TableCell>Simulate Vendor</TableCell>
              <TableCell>Simulate MC</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {testPlans.map((testPlan, index) => (
              <TableRow
                onClick={() => handleClick(testPlan)}
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {testPlan.testCell}
                </TableCell>
                <TableCell>{testPlan.generatedCell}</TableCell>
                <TableCell>
                  {new Date(testPlan.targetEndDate).toLocaleString()}
                </TableCell>
                <TableCell>{testPlan.status}</TableCell>
                <TableCell>{testPlan.note}</TableCell>
                <TableCell>{testPlan.simulateVendor.toString()}</TableCell>
                <TableCell>{testPlan.simulateMc.toString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <FlightTestContext
        testPlan={selected}
        open={menuOpen}
        handleExit={handleClose}
      />
    </div>
  );
};
const mapStateToProps = state => ({
  cells: state.orders.cells,
  selectedCellId: state.orders.selectedCellId,
  pads: state.liveAircraft.pads,
  testPlans: state.flightTestPlans.testPlans
});

const mapDispatchToProps = dispatch => ({
  getCells: () => dispatch(getCells()),
  getRegions: () => dispatch(getRegions()),
  getLandingPads: () => dispatch(getLandingPads()),
  getFlightTestPlansForCell: (cellId: number) =>
    dispatch(getFlightTestPlansForCell(cellId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewFlightTestPlans);
